module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems.e01c7e4e6def1398f9c4e8200b8451c3.png";